var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h5", { staticClass: "grey-color fw-600" }, [
        _vm._v("Подтверждение требований к поставщикам"),
      ]),
      _vm.purchaseItem.supplier_reqs_a
        ? [
            _c("text-row-boolean-text", {
              attrs: {
                compact: "",
                "label-cols-lg": 11,
                "label-cols-sm": 11,
                label:
                  "Поставщик подтвердил, что соответствует требованиям п.1 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
                value: _vm.offer.reply_supplier_reqs_a,
                "value-class": "text-right",
              },
            }),
            _c("text-row", {
              attrs: {
                compact: "",
                "label-cols-lg": 5,
                "label-cols-sm": 5,
                label:
                  "Поставщик подтвердил соответствие следующим требованиям",
              },
              model: {
                value:
                  _vm.purchaseItem.supplier_requirements.supplier_reqs_a_text,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.purchaseItem.supplier_requirements,
                    "supplier_reqs_a_text",
                    $$v
                  )
                },
                expression:
                  "purchaseItem.supplier_requirements.supplier_reqs_a_text",
              },
            }),
            _c("supplier-requirement-supplier-reqs-a-view-table", {
              attrs: { documents: _vm.offer.supplier_required_documents },
            }),
          ]
        : _vm._e(),
      _vm.purchaseItem.supplier_reqs_b
        ? _c("text-row-boolean-text", {
            attrs: {
              compact: "",
              "label-cols-lg": 11,
              "label-cols-sm": 11,
              label:
                "Поставщик подтвердил, что соответствует требованиям п.3-5, 7-11 ч.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
              value: _vm.offer.reply_supplier_reqs_b,
              "value-class": "text-right",
            },
          })
        : _vm._e(),
      _vm.purchaseItem.supplier_reqs_c
        ? _c("text-row-boolean-text", {
            attrs: {
              compact: "",
              "label-cols-lg": 11,
              "label-cols-sm": 11,
              label:
                "Поставщик подтвердил, что соответствует требованиям ч.1.1 ст.31 Федерального закона «О контрактной системе в сфере закупок товаров, работ, услуг для обеспечения государственных и муниципальных нужд» от 05.04.2013 №44-ФЗ",
              value: _vm.offer.reply_supplier_reqs_b,
              "value-class": "text-right",
            },
          })
        : _vm._e(),
      _vm.purchaseItem.supplier_reqs_sonko
        ? _c("text-row-boolean-text", {
            attrs: {
              compact: "",
              "label-cols-lg": 11,
              "label-cols-sm": 11,
              label: "Поставщик подтвердил, что является СОНКО",
              hint: "Социально ориентированная некоммерческая организация",
              value: _vm.offer.reply_supplier_reqs_sonko,
              "value-class": "text-right",
            },
          })
        : _vm._e(),
      _vm.purchaseItem.supplier_requirements.additional.state[0]
        ? [
            _c("text-row-boolean-text", {
              attrs: {
                compact: "",
                "label-cols-lg": 11,
                "label-cols-sm": 11,
                label:
                  "Поставщик подтвердил соответствие дополнительным требованиям",
                value: _vm.offer.supplier_requirements.additional.state[1],
                "value-class": "text-right",
              },
            }),
            _c("additional-supplier-requirements-view-table", {
              attrs: {
                documents:
                  _vm.offer.supplier_requirements.additional.requirements,
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }